import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/customers";

// Fetch all customers
export const getCustomers = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/list`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

// Create a new customer
export const createCustomer = async (customerData: any) => {
  try {
    const response = await axios.post(`${BASE_URL}/create`, customerData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating customer:", error);
    throw error;
  }
};

// Update an existing customer
export const updateCustomer = async (id: number, customerData: any) => {
  try {
    const response = await axios.put(`${BASE_URL}/update/${id}`, customerData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};

// Delete a customer
export const deleteCustomer = async (id: string) => {
  try {
    const response = await axios.delete(`${BASE_URL}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting customer:", error);
    throw error;
  }
};

// Fetch all master accounts
export const fetchMasterAccounts = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/master-accounts`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching master accounts:", error);
    throw error;
  }
};

// Create a new subaccount
export const createSubaccount = async (data: {
  masterCustomerId: number;
  name: string;
  email: string;
  phone: string;
  shippingAddress: string;
  password?: string; // Optional password field
}) => {
  try {
    const response = await axios.post(`${BASE_URL}/subaccounts`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating subaccount:", error);
    throw error;
  }
};

// Fetch subaccounts for a master account
export const fetchSubaccounts = async (masterCustomerId: number) => {
  try {
    const response = await axios.get(`${BASE_URL}/${masterCustomerId}/subaccounts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subaccounts:", error);
    throw error;
  }
};

// Update a subaccount
export const updateSubaccount = async (
  subaccountId: number,
  data: { name: string; email: string; phone: string; shippingAddress: string; password?: string }
) => {
  try {
    const response = await axios.put(`${BASE_URL}/subaccounts/${subaccountId}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating subaccount:", error);
    throw error;
  }
};

// Delete a subaccount
export const deleteSubaccount = async (subaccountId: number) => {
  try {
    const response = await axios.delete(`${BASE_URL}/subaccounts/${subaccountId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting subaccount:", error);
    throw error;
  }
};


// Toggle subaccount creation for a master account
export const toggleSubaccountCreation = async (customerId: number, allowSubaccounts: boolean) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/toggle-subaccount-creation/${customerId}`,
      { allow_subaccount_creation: allowSubaccounts },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling subaccount creation:", error);
    throw error;
  }
};


// Set outstanding balance limit for a master account
export const setOutstandingLimit = async (customerId: number, limit: number) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/${customerId}/set-outstanding-limit`,
      { limit },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error setting outstanding balance limit:", error);
    throw error;
  }
};

// Fetch outstanding balance for a master account
export const getOutstandingBalance = async (customerId: number) => {
  try {
    const response = await axios.get(`${BASE_URL}/${customerId}/outstanding-balance`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data; // Returns { outstandingBalance: number, outstandingLimit: number }
  } catch (error) {
    console.error("Error fetching outstanding balance:", error);
    throw error;
  }
};

export const getOutstandingBalanceForMaster = async (masterCustomerId: number) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/${masterCustomerId}/outstanding-balance`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
    return response.data.outstandingBalance;
  } catch (error) {
    console.error("Error fetching outstanding balance:", error);
    throw error;
  }
};

// customerApi.js
export const toggleCustomerActive = async (
  customerId: number,
  active: boolean
): Promise<void> => {
  try {
    const response = await axios.put(
      `${BASE_URL}/toggle-active/${customerId}`,
      { active },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling customer status:", error);
    throw error;
  }
};